import React, { useEffect, useState, useRef, useLayoutEffect } from "react";

// import img_profile from "../../../assets/img/ci/profile/img-profile.png";

const CardPartner = (props) => {
  const [height, setHeight] = useState(0);
  const eleRef = useRef(null);

  useEffect(() => {
    // console.log(props.index, height, props.curHeight);
    props.setNewHeight(props.index, height);
  }, [height]);

  useLayoutEffect(() => {
    const handleResize = () => {
      setHeight(eleRef.current.offsetHeight);
    };
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Generate thumbnail from name if imgLineUrl is empty or null
  const generateThumbnail = (name) => {
    if (!name) return "";

    // Get first character of fullname
    const initials = name.trim().charAt(0).toUpperCase();

    // Generate a color based on the name (for consistent colors)
    const colors = [
      "#FF6B6B",
      "#4ECDC4",
      "#45B7D1",
      "#96CEB4",
      "#FFEAA7",
      "#DDA15E",
      "#BC4749",
      "#6C757D",
      "#17A2B8",
      "#28A745",
    ];
    const colorIndex = name.charCodeAt(0) % colors.length;
    const bgColor = colors[colorIndex];

    // Create SVG data URL
    const svg = `
      <svg width="250" height="250" xmlns="http://www.w3.org/2000/svg">
        <rect width="250" height="250" fill="${bgColor}"/>
        <text x="125" y="125" font-family="Arial, sans-serif" font-size="90" fill="white" text-anchor="middle" dominant-baseline="central" font-weight="bold">${initials}</text>
      </svg>
    `.trim();

    return `data:image/svg+xml;base64,${btoa(
      unescape(encodeURIComponent(svg))
    )}`;
  };

  const getImageSrc = () => {
    const imgUrl = props.dataPartner.imgLineUrl;
    if (!imgUrl || imgUrl.trim() === "") {
      return generateThumbnail(props.dataPartner.fullname);
    }
    return imgUrl;
  };

  return (
    <div className="bMember" ref={eleRef}>
      <div className="bMemberInfo">
        <div className="bMemberImg">
          <img
            src={getImageSrc()}
            alt="Profile"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
        <div className="bMemberName">
          <h3>{props.dataPartner.fullname}</h3>
          <p>ID: {props.dataPartner.id}</p>
        </div>
      </div>
      <a
        className="btnDelete"
        onClick={props.handleDelete}
        aria-label="Delete"
      ></a>
    </div>
  );
};

export default CardPartner;
